<template>
  <div v-loading="loading" element-loading-spinner="atom-audit-loader">
    <table class="hiaTable printable-by-code">
      <thead>
        <tr>
          <th>Code</th>
          <th>Description</th>
          <th>Occur.</th>
          <th>No<br>Changes</th>
          <th>Del.</th>
          <th>Revised<br>From</th>
          <th>Accuracy<br>Rate</th>
          <th>Adds</th>
          <th>Revised<br>To</th>
          <th>% of<br>Missed</th>

        </tr>
      </thead>
      <tr v-for="(row, i) in tableData" :key="i">
        <td class="textAlignLeft">{{row.code}}</td>
        <td class="textAlignLeft">{{row.description}}</td>
        <td>{{row.totalRecords}}</td>
        <td>{{row.pxNoRec}}</td>
        <td>{{row.pxDeletions}}</td>
        <td>{{row.revisedFromCount}}</td>
        <td>{{ formatPercentage(row.pcsCodes) }}</td>
          <td>{{row.pxAdditions}}</td>
        <td>{{row.revisedToCount}}</td>
        <td>{{ formatPercentage(row.percentOfMissedOpportunities) }}</td>

      </tr>
      <tr class="strong emphasis" v-if="tableData.length > 0">
        <td class="textAlignLeft">Totals</td>
        <td></td>
        <td>{{summary[2]}}</td>
        <td>{{summary[3]}}</td>
        <td>{{summary[4]}}</td>
        <td>{{summary[5]}}</td>
        <td>{{summary[6]}}</td>
        <td>{{summary[7]}}</td>
        <td>{{summary[8]}}</td>
        <td>{{summary[9]}}</td>
      </tr>
      <tr v-if="tableData.length === 0">
        <td colspan="10" class="textAlignLeft">{{loading ? 'loading...' : 'No Px Data Found'}}</td>
      </tr>
    </table>

  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import axios from '@/utilities/axios-global'
  import hiaFilters from '@/mixins/hiaFilters'
  import money from '@/mixins/money'
  import dashboardHelper from '@/mixins/dashboardHelper'

  export default {
    name: 'IP_PxSummaryPrintable',
    mixins: [hiaFilters, money, dashboardHelper],
    props: ['drgTableIds'],
    components: {},
    data: function () {
      return {
        tableData: [],
        filterCriteria: '',
        loading: false,
        dialogVisible: false,
        summaryDialogVisible: false,
        subDrgTableIds: null,
        summaryRow: {}
      }
    },
    methods: {
      async getData() {
        const payload = {
          drgTableIds: this.drgTableIds,
          includeAccts: true,
          statType: 'test'
        }
        try {
          this.loading = true
          const response = await axios.post(this.baseApiUrl + '/reports/dashboard/ipPx', payload)
          this.tableData = response.data.data
          this.attachMissedOpportunityPct(this.tableData, 'pxAdditions', 'revisedToCount')
        } catch (err) {
          this.tableData = []
        } finally {
          this.loading = false
        }
      },
      showSummary(row) {
        this.summaryRow = row
        this.summaryDialogVisible = !this.summaryDialogVisible
      },
      getSummaries(param) {
        return this.getSummary(param)
      }
    },
    computed: {
      ...mapState('user/', ['baseApiUrl']),
      summary: function () {
        const param = {
          columns: [
            { property: 'code' },
            { property: 'description' },
            { property: 'totalRecords' },
            { property: 'pxNoRec' },
            { property: 'pxDeletions' },
            { property: 'revisedFromCount' },
            { property: 'pcsCodes' },
            { property: 'pxAdditions' },
            { property: 'revisedToCount' },
            { property: 'percentOfMissedOpportunities' }

          ],
          data: this.tableData
        }
        return this.getSummary(param)
      }
    },
    mounted: async function () {
      await this.getData()
    },
    watch: {
      drgTableIds: async function () {
        await this.getData()
      }
    }
  }
</script>

<style scoped>
.hiaTable thead th {
  text-align: center;
}

.hiaTable tr td {
  text-align: right;
}
</style>
